import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {findIndex} from 'lodash';
import './summary.scss';

class SummarySetsOrders extends Component {
  renderLoaderOrOrders() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  }

  renderTableInformation() {
    const {partsList, activeTabIndex} = this.props;
    const colSpan = activeTabIndex === 0 ? 7 : 5;

    if (!partsList.length) {
      return (
        <Table.Row textAlign='center'>
          <Table.Cell colSpan={colSpan}>
            No hay pedidos en el periodo de tiempo seleccionado
          </Table.Cell>
        </Table.Row>
      );
    }

    return partsList.map((order, index) => {
      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell>{order.partCode}</Table.Cell>
          <Table.Cell>{order.partName}</Table.Cell>
          <Table.Cell>{order.quantityByVehicle}</Table.Cell>
          <Table.Cell>{order.totalVehicles}</Table.Cell>
          <Table.Cell>{order.totalQuantity}</Table.Cell>
          {this.renderStock(activeTabIndex, order.partCode, 'CPD')}
          {this.renderStock(activeTabIndex, order.partCode, 'TMP')}
        </Table.Row>
      );
    });
  }

  renderStock(activeTabIndex, partCode, type) {
    if (activeTabIndex === 1) {
      return null;
    }
    const {stock} = this.props;
    const index = findIndex(stock, {'partCode': partCode});
    if (index === -1) {
      return <Table.Cell>0</Table.Cell>;
    }

    const object = stock[index];

    if (type === 'CPD') {
      return <Table.Cell>{object.availableStockCpd}</Table.Cell>;
    }
    return <Table.Cell>{object.availableStockTmp}</Table.Cell>;
  }

  render() {
    const {activeTabIndex} = this.props;
    return (
      <Card raised fluid>
        <Table striped className='summary-sets-orders scrollable-body'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell>Código del Item</Table.HeaderCell>
              <Table.HeaderCell>Nombre</Table.HeaderCell>
              <Table.HeaderCell>Cantidad Requerida por Auto</Table.HeaderCell>
              <Table.HeaderCell>
                Número de Autos a ser atendidos
              </Table.HeaderCell>
              <Table.HeaderCell>Cantidad Total Requerida</Table.HeaderCell>
              {activeTabIndex === 0 ? (
                <Table.HeaderCell>CPD</Table.HeaderCell>
              ) : null}
              {activeTabIndex === 0 ? (
                <Table.HeaderCell>TMP</Table.HeaderCell>
              ) : null}
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderLoaderOrOrders()}</Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.setsOrders.loading,
    'partsList': state.setsOrders.partsList,
    'stock': state.setsOrders.availableStock,
  };
};

export default connect(mapStateToProps)(SummarySetsOrders);
